import IdCard from './IdCard';
import IdCardHowItWorks from './HowItWorks';
import WhySchoolLoveAiPowredIdCard from './WhySchoolLoveAiPowredIdCard';
import LandingPageComponentWrapper from '../components/LandingPageComponentWrapper';
import { FAQSection } from '../AvatarDigitalMarketer/FAQSection';

const faqItemsForIdCards = [
    {
        id: 1,
        question: "Do we need new photos?",
        answer:
            "No. Use old photos — AI will enhance them. New photos also work great.",
    },
    {
        id: 2,
        question: "Can the QR do both attendance and payments?",
        answer:
            "Yes. One QR code can be used for both scanning to mark attendance and for fee payments.",
    }
];

const componentsList = [
    { component: <IdCard />, bgColor: "bg-[#ECECF7]", id: "idcard-IdCard" },
    { component: <IdCardHowItWorks />, bgColor: "", id: "idcard-IdCardHowItWorks" },
    { component: <WhySchoolLoveAiPowredIdCard />, bgColor: "bg-[#ECECF7]", id: "idcard-WhySchoolLoveAiPowredIdCard" },
    { component: <FAQSection faqItems={faqItemsForIdCards} />, bgColor: "", id: "idcard-FAQSection", isFlex1: true },
]

const AvatarIDCards = () => {
    return <div className="bg-[#FCFAFF]  mt-40" style={{
        position: "relative",
        zIndex: 1,
        // backgroundColor: "transparent",
    }}>
        {componentsList.map((element: any, index) => (
            <div
                key={"components" + index}
                id={element?.id}
            // ref={(el) => (sectionRefs.current[index] = el) as any}
            >
                <LandingPageComponentWrapper bg={element?.bgColor} isFlex1={element?.isFlex1}>
                    {element?.component}
                </LandingPageComponentWrapper>
            </div>
        ))}
    </div>
}

export default AvatarIDCards;